"use client"

import Image from "next/image"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { getProductUrl } from "@lib/util/product"
import WishlistButton from "@modules/common/components/wishlist-button"

type Props = {
  product: {
    id: string
    title: string | null
    handle: string | null
    thumbnail: string | null
  }
  price: string | null
  compact?: boolean
}

export default function StoreProductCard({ product, price, compact = false }: Props) {
  return (
    <LocalizedClientLink
      href={getProductUrl(product.handle)}
      className="group block"
    >
      <div className="relative aspect-[4/5] mb-3 bg-gray-50 rounded-lg overflow-hidden">
        {product.thumbnail ? (
          <Image
            src={product.thumbnail}
            alt={product.title ?? ""}
            fill
            className="object-contain p-3 group-hover:scale-105 transition-transform duration-300"
            sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-gray-300">
            No image
          </div>
        )}
        <WishlistButton productId={product.id} productTitle={product.title ?? ""} />
      </div>
      <h3 className="text-sm font-medium text-gray-900 line-clamp-2 mb-1.5 min-h-[40px]">
        {product.title}
      </h3>
      {price && (
        <p className="text-sm font-bold text-gray-900 mb-3">
          {price}
        </p>
      )}
      {!compact && (
        <span className="block w-full py-2.5 text-sm font-semibold text-center rounded-full bg-brand-hero-navy text-white group-hover:bg-brand-primary-blue transition-colors">
          Add to cart
        </span>
      )}
    </LocalizedClientLink>
  )
}
